
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import TapdUI from '@tencent/tapd-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'v-clipboard';
import TapdBridge from '@tencent/tapd-open-js-sdk';

import App from './App.vue';
import router from './router';
import store from './store';
import VueLocalStorage from 'vue-localstorage';
// import ErrorPlugin from './util/errorPlugin';

import './util/icon/svg';
import SvgIcon from './components/common/svg-icon';
import InitAppMessage from './util/app-message/init';
import InitDirective from './directive';

import Enlocales from '../locales/en.json';
import ZHlocales from '../locales/zh_CN.json';
import JaLocales from '../locales/ja.json';

const $tapduiTranslations = Vue.prototype.$t;

Vue.config.productionTip = false;

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(VueLocalStorage)
// Vue.use(ErrorPlugin)
Vue.component('svg-icon', SvgIcon);
Vue.use(TapdUI);
Vue.use(VueI18n);

Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$_t = Vue.prototype.$t;
Vue.prototype.$t = $tapduiTranslations;

InitDirective()

function getLang() {
    const hash = window.location.hash || '';
    const [, queryInHash = ''] = hash.split('?') || [];
    const query = queryInHash.split('&').reduce((dict, field = '') => {
        const [key, value] = field.split('=') || [];
        if (key) {
            dict[key] = value;
        }
        return dict;
    }, {})
    return query._lang;
}

const messages = {
    en: Enlocales,
    zh_CN: ZHlocales,
    ja: JaLocales,
}

const i18n = new VueI18n({
    locale: getLang() || 'zh_CN',
    fallbackLocale: 'zh_CN',
    messages,
    formatFallbackMessages: true,
})

// 历史遗留信息放在hash中。古董
const hash = window.location.hash.slice(1);
const fakeUrl = new URL(hash, location.origin);
const code = fakeUrl.searchParams.get('code');
store.dispatch('setLanguage', getLang() || 'zh_CN')

window.app = new Vue({
    router,
    store,
    i18n,
    beforeMount() {
        InitAppMessage();
        this.tapdBridge = new TapdBridge({
            code: code
        });
    },
    render: h => h(App)
}).$mount('#app');
